module.exports = __webpack_public_path__ + "img/ic_cal_xsmall.12fbfc83.svg";